export const FIRST_PAGE_INDEX = 1;

export type PageLocationState = {
  page?: number;
  [key: string]: unknown;
};

export const withPageLocationState = (
  state: unknown,
  page: number,
): PageLocationState => ({
  ...(state !== null && typeof state === 'object'
    ? (state as Record<string, unknown>)
    : {}),
  page,
});

export const readPageFromLocationState = (
  state: unknown,
): number | undefined => {
  if (!state || typeof state !== 'object' || !('page' in state)) {
    return undefined;
  }

  const { page } = state as PageLocationState;

  if (
    typeof page !== 'number' ||
    !Number.isInteger(page) ||
    page < FIRST_PAGE_INDEX
  ) {
    return undefined;
  }

  return page;
};
